<template>
  <Breadcrumb
    :items="items"
    :all-white="allWhite"
    :full-background="fullBackground"
  />
</template>

<script>
import Breadcrumb from '@/components/breadcrumb.vue';

export default {
  name: 'SingleLevelBreadcrumb',
  components: {
    Breadcrumb,
  },
  props: {
    label: {
      type: String,
      default: null,
    },
    allWhite: { type: Boolean },
    fullBackground: { type: Boolean },
    noLink: { type: Boolean },
  },
  computed: {
    items() {
      if (!this.label) return [];
      if (this.noLink) return [{ label: this.label }];
      return [{ label: this.label, to: this.$route.path }];
    },
  },
};
</script>
